(() => {
  const render = (element, cents) => {
    const rate = Number(element.dataset.rate);
    const amount = Number(cents);
    if (!Number.isFinite(rate) || rate <= 0 || !Number.isFinite(amount)) return;
    const colones = Math.round((amount / 100) * rate);
    element.textContent = `aprox. ₡${String(colones).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
  };

  const initialize = (root) => {
    const elements = root.matches?.('[data-cp-colones]') ? [root] : root.querySelectorAll?.('[data-cp-colones]') || [];
    elements.forEach((element) => {
      if (element.dataset.cpColonesReady === 'true') return;
      element.dataset.cpColonesReady = 'true';
      render(element, element.dataset.cents);
      if (element.dataset.productId) {
        window.addEventListener(`theme:product:${element.dataset.productId}:variantChanged`, (event) => {
          if (event.detail?.variant?.price != null) render(element, event.detail.variant.price);
        });
      }
    });
  };

  const start = () => {
    initialize(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initialize(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
